// 1
import { commitMutation } from "react-relay";
import graphql from "babel-plugin-relay/macro";

// import { ConnectionHandler } from "relay-runtime";
import environment from "../Environment";
// 2
const mutation = graphql`
  mutation UserRoleEditMutation($roleID: String!, $userID: ID!) {
    editUserRole(roleID: $roleID, userID: $userID) {
      name
    }
  }
`;
// 3
export default (roleID, userID, callback) => {
  // 4
  const variables = {
    roleID,
    userID
  };
  // 5
  commitMutation(environment, {
    mutation,
    variables,
    // 6
    // optimisticUpdater: proxyStore => {
    //   // ... you'll implement this in a bit
    // },
    // updater: proxyStore => {
    //   // ... this as well
    // },
    // 7
    onCompleted: (data, errors) => {
      callback(data, errors);
    },
    onError: (error) => {
      callback(
        undefined,
        Array.isArray(error.codes) ? error.codes : ["networkerror"]
      );
    }
  });
};
